
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Mulhouse dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Mulhouse certifiée Google Partner, accompagne les entreprises mulhousiennes pour développer leur visibilité en ligne et attirer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Mulhouse dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Mulhouse certifiée Google Partner, accompagne les entreprises mulhousiennes pour développer leur visibilité en ligne et attirer plus de clients.",
        },
      ],
    };
  },
};
